"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ifMatches = void 0;
const render_manager_1 = require("./render-manager");
const ifMatches = async (matches, element, hash, routes, options) => {
    if (!matches) {
        const notFoundMatcher = routes.find(({ path }) => path.at(0) === '*');
        if (notFoundMatcher) {
            await (0, render_manager_1.handleRenderization)(notFoundMatcher, hash, element);
            options?.onUpdate?.(notFoundMatcher);
        }
        else {
            (0, render_manager_1.clearElement)(element);
            options?.onUpdate?.(null);
        }
        return;
    }
    if (!matches.component &&
        matches.children?.length === 0 &&
        !matches.loadChild) {
        return;
    }
    if (matches.canActivate) {
        if (matches.canActivate(matches)) {
            await (0, render_manager_1.handleRenderization)(matches, hash, element);
            options?.onUpdate?.(matches);
        }
        return;
    }
    await (0, render_manager_1.handleRenderization)(matches, hash, element);
    options?.onUpdate?.(matches);
};
exports.ifMatches = ifMatches;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWF0Y2hlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9wYWNrYWdlcy9yb3V0aW5nL3V0aWxzL21hdGNoZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQ0EscURBQXFFO0FBRTlELE1BQU0sU0FBUyxHQUFHLEtBQUssRUFDNUIsT0FBc0IsRUFDdEIsT0FBb0IsRUFDcEIsSUFBYyxFQUNkLE1BQWdCLEVBQ2hCLE9BQWtDLEVBQ2xDLEVBQUU7SUFDRixJQUFJLENBQUMsT0FBTyxFQUFFO1FBQ1osTUFBTSxlQUFlLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQyxDQUFDLEVBQUUsSUFBSSxFQUFFLEVBQUUsRUFBRSxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLEtBQUssR0FBRyxDQUFDLENBQUM7UUFFdEUsSUFBSSxlQUFlLEVBQUU7WUFDbkIsTUFBTSxJQUFBLG9DQUFtQixFQUFDLGVBQWUsRUFBRSxJQUFJLEVBQUUsT0FBTyxDQUFDLENBQUM7WUFDMUQsT0FBTyxFQUFFLFFBQVEsRUFBRSxDQUFDLGVBQWUsQ0FBQyxDQUFDO1NBQ3RDO2FBQU07WUFDTCxJQUFBLDZCQUFZLEVBQUMsT0FBTyxDQUFDLENBQUM7WUFDdEIsT0FBTyxFQUFFLFFBQVEsRUFBRSxDQUFDLElBQUksQ0FBQyxDQUFDO1NBQzNCO1FBRUQsT0FBTztLQUNSO0lBRUQsSUFDRSxDQUFDLE9BQU8sQ0FBQyxTQUFTO1FBQ2xCLE9BQU8sQ0FBQyxRQUFRLEVBQUUsTUFBTSxLQUFLLENBQUM7UUFDOUIsQ0FBQyxPQUFPLENBQUMsU0FBUyxFQUNsQjtRQUVBLE9BQU87S0FDUjtJQUdELElBQUksT0FBTyxDQUFDLFdBQVcsRUFBRTtRQUN2QixJQUFJLE9BQU8sQ0FBQyxXQUFXLENBQUMsT0FBTyxDQUFDLEVBQUU7WUFDaEMsTUFBTSxJQUFBLG9DQUFtQixFQUFDLE9BQU8sRUFBRSxJQUFJLEVBQUUsT0FBTyxDQUFDLENBQUM7WUFDbEQsT0FBTyxFQUFFLFFBQVEsRUFBRSxDQUFDLE9BQU8sQ0FBQyxDQUFDO1NBQzlCO1FBRUQsT0FBTztLQUNSO0lBR0QsTUFBTSxJQUFBLG9DQUFtQixFQUFDLE9BQU8sRUFBRSxJQUFJLEVBQUUsT0FBTyxDQUFDLENBQUM7SUFDbEQsT0FBTyxFQUFFLFFBQVEsRUFBRSxDQUFDLE9BQU8sQ0FBQyxDQUFDO0FBQy9CLENBQUMsQ0FBQztBQTNDVyxRQUFBLFNBQVMsYUEyQ3BCIn0=